enum TimelineItemTypes {
  ProductionOrder = "ProductionOrder",
  Operation = "Operation",
  Activity = "Activity",
  PlanningStep = "PlanningStep",
  ProcessStep = "ProcessStep",
  Project = "Project",
  OrderPosition = "OrderPosition",
  ResourceConflict = "ResourceConflict",
  DateConflict = "DateConflict",
  OperationStatusConflict = "OperationStatusConflict",
  FrozenZone = "FrozenZone",
}

export default TimelineItemTypes
